// Thư mục: src/stores/giayToStore.js
import { defineStore } from "pinia";
import {
  GiayToApi,
  XeOptionsApi,
  TaiXeOptionsApi,
} from "@/services/giayToService"; // Import các API service

export const useGiayToStore = defineStore("giayTo", {
  state: () => ({
    // State cho danh sách giấy tờ (phân trang)
    isLoading: false,
    error: null,
    items: [], // Danh sách hiển thị trên table

    // State phân trang
    page: 0,
    size: 10,
    sort: "ngayHetHan,asc", // Sắp xếp theo ngày hết hạn
    totalPages: 1,
    totalElements: 0,

    // State cho options dropdowns trong modal
    xeOptions: [],
    taiXeOptions: [],
    isLoadingOptions: false,
  }),

  getters: {
    currentPage(state) {
      return state.page + 1;
    },
  },

  actions: {
    // --- Actions Phân trang ---
    setPage(p1) {
      const p0 = Math.max(0, p1 - 1);
      if (p0 !== this.page) this.page = p0;
    },
    setSize(s) {
      this.size = s;
      this.page = 0;
    },
    // (Có thể thêm setSort nếu cần)

    // --- Action Tải danh sách Giấy tờ ---
    async fetchList() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await GiayToApi.list({
          page: this.page,
          size: this.size,
          sort: this.sort,
        });
        // items là GiayToResponse (có xeId, xeBienSo, nguoiDungId, nguoiDungHoTen)
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
        this.size = data.size ?? this.size;
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh sách giấy tờ";
        console.error("fetchList GiayTo error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    // --- Action Tải Options cho Modal ---
    async fetchOptionsIfNeeded() {
      // Chỉ tải nếu chưa có dữ liệu
      if (this.xeOptions.length > 0 && this.taiXeOptions.length > 0) {
        return;
      }
      this.isLoadingOptions = true;
      try {
        // Gọi song song 2 API
        const [xeData, taiXeData] = await Promise.all([
          XeOptionsApi.listForSelect(),
          TaiXeOptionsApi.listForSelect(),
        ]);
        // Lưu dữ liệu options
        this.xeOptions = xeData || [];
        // API Tài xế trả về NguoiDungResponse, cần map lại cho gọn
        this.taiXeOptions = (taiXeData || []).map((nd) => ({
          id: nd.idNguoiDung, // Lấy ID
          hoTen: nd.hoTen, // Lấy Tên
        }));
      } catch (e) {
        console.error("Lỗi tải options Xe/Tài xế:", e);
        // Có thể set error riêng
      } finally {
        this.isLoadingOptions = false;
      }
    },

    // --- Actions CRUD Giấy tờ ---
    // Nhận vào GiayToRequestDto
    async createGiayTo(form) {
      await GiayToApi.create(form);
      await this.fetchList(); // Tải lại list sau khi tạo
    },

    // Nhận vào GiayToRequestDto
    async updateGiayTo(id, form) {
      await GiayToApi.update(id, form);
      await this.fetchList(); // Tải lại list sau khi sửa
    },

    async deleteGiayTo(id) {
      await GiayToApi.remove(id);
      // Logic lùi trang nếu cần
      if (this.items.length === 1 && this.page > 0) {
        this.page -= 1;
      }
      await this.fetchList(); // Tải lại list
    },
  },
});
